// @flow

import AExperimentsClient from 'app/common/lib/ExperimentsClient/AExperimentsClient';

export default class EmptyExperimentsClient extends AExperimentsClient {
  constructor() {
    super({}, {}, false);
  }

  v2ActivateExperiment(name: string): ?string {
    return null;
  }

  v2LogExperimentGroupOverride(name: string, overrideGroup: string, isSeoExp: ?boolean): void {}
}
